export enum NdsIconSize {
  M = 24,
  S = 20,
  XS = 16,
}

export enum NdsIconType {
  CHEVRON_LEFT = 'ChevronLeft',
  CHEVRON_RIGHT = 'ChevronRight',
  CHEVRON_UP = 'ChevronUp',
  CHEVRONS_UP = 'ChevronsUp',
  CHEVRON_DOWN = 'ChevronDown',
  CHEVRONS_UP_DOWN = 'ChevronsUpDown',
  CIRCLE_X = 'CircleX',
  CIRCLE_HELP = 'CircleHelp',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  ARROW_UP_FROM_LINE = 'ArrowUpFromLine',
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
  ARROW_DOWN_TO_LINE = 'ArrowDownToLine',
  ARROW_RIGHT_TO_LINE = 'ArrowRightToLine',
  ARROW_UP_DOWN = 'ArrowUpDown',
  BOX = 'Box',
  PLUS = 'Plus',
  ELLIPSIS_VERTICAL = 'EllipsisVertical',
  CLOSE = 'X',
  PENCIL = 'Pencil',
  LINK = 'Link',
  LINK_2_OFF = 'Link2Off',
  GLOBE = 'Globe',
  CHECK = 'Check',
  SQUARE_CHECK = 'SquareCheck',
  CIRCLE_ALERT = 'CircleAlert',
  OCTAGON_ALERT = 'OctagonAlert',
  FLAME = 'Flame',
  MESSAGE_SQUARE = 'MessageSquare',
  MESSAGE_SQUARE_PLUS = 'MessageSquarePlus',
  INFO = 'Info',
  SQUARE_ARROW_OUT_UP_RIGHT = 'SquareArrowOutUpRight',
  TRASH_2 = 'Trash2',
  ITERATION_CW = 'IterationCw',
  MESSAGE_CIRCLE_WARNING = 'MessageCircleWarning',
  TRENDING_UP = 'TrendingUp',
  LINE_CHART = 'LineChart',
  NOTEBOOK_PEN = 'NotebookPen',
  PLAY = 'Play',
  SKIP_FORWARD = 'SkipForward',
  PEN = 'Pen',
  CALENDAR_DAYS = 'CalendarDays',
  SEARCH = 'Search',
  CORNER_DOWN_RIGHT = 'CornerDownRight',
  FILE = 'File',
  NETWORK = 'Network',
  COPY = 'Copy',
  MOVE = 'Move',
  USER_CIRCLE = 'UserCircle',
  USERS = 'Users',
  TRAFFIC_CONE = 'TrafficCone',
  CLIPBOARD_CHECK = 'ClipboardCheck',
  GAUGE = 'Gauge',
  BOXES = 'Boxes',
  TRELLO = 'Trello',
  LIST = 'List',
  CHARTPIE = 'ChartPie',
  TIMER = 'Timer',
  MORE_VERTICAL = 'MoreVertical',
  MAIL = 'Mail',
  ALERT_TRIANGLE = 'AlertTriangle',
  EYE = 'Eye',
  EYE_OFF = 'EyeOff',
  LIGHTBULB = 'Lightbulb',
  COG = 'Cog',
  SETTINGS = 'Settings',
  MESSAGE_CIRCLE_QUESTION = 'MessageCircleQuestion',
  CIRCLE_DOT_DASHED = 'CircleDotDashed',
  SHIELD_CHECK = 'ShieldCheck',
  TAGS = 'Tags',
  SEND = 'Send',
  LOCK = 'Lock',
  HARD_HAT = 'HardHat',
}
